import { render, staticRenderFns } from "./bookingIndex.vue?vue&type=template&id=05e88e04&scoped=true"
import script from "./bookingIndex.vue?vue&type=script&lang=js"
export * from "./bookingIndex.vue?vue&type=script&lang=js"
import style0 from "./bookingIndex.vue?vue&type=style&index=0&id=05e88e04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e88e04",
  null
  
)

export default component.exports